<tilled-table
  [data]="(usersAndInvitesViewModel$ | async)!"
  [getPageCallback]="getUsersAndInvites"
  [dataLength]="(usersCount$ | async) + (userInvitationsCount$ | async)"
  [noDataMainText]="'No users or invitations found'"
  [noDataSecondaryText]="''"
  data-test-id="users-and-invites-table"
></tilled-table>
